import { useEffect, useState } from "react"
import { Button, Input } from "reactstrap"
import { showAlert } from "src/modules/app_sigo/helpers/ui"
import { useForceUpdate } from "src/modules/app_sigo/hooks/useForceUpdate"
import styled from "styled-components"
import { HCF, HUtils } from "@macashipo/mlib"
import { MyUI } from "src/core/components"
import { MdArrowBackIos, MdOutlineRemoveRedEye } from "react-icons/md"
import { ImEyeBlocked } from "react-icons/im"
import { BiInfoCircle } from "react-icons/bi"

const MyUIEnterNewPassword = props => {
  const { isActive, fnList } = props
  const [showPwd, setShowPwd] = useState(false)
  const [showConfirmPwd, setShowConfirmPwd] = useState(false)
  const [data, setData] = useState({} as any)
  const [msg, setMsg] = useState("")
  const [loading, setLoading] = useState(false)
  const [keyUIInput, forceUpdateKeyInput] = useForceUpdate()
  const dfMsgInfo = HUtils.get(HCF.getCF("websiteSetting"), "auth") || {}

  useEffect(() => {
    // Reset new password và confirm password
    if (isActive) {
      setShowConfirmPwd(false)
      setShowPwd(false)
      setMsg("")
      setData({})
      forceUpdateKeyInput()
    }
  }, [isActive])
  const configFieldData = {
    newPwd: "Password",
    confirmPwd: "ConfirmPassword",
  }
  const checkValidPass = value => {
    if (value?.length >= 9) {
      return true
    }
    return false
  }
  const handlePassword = (field, value) => {
    setMsg("")
    let newData = { ...data }
    if (field) {
      newData[field] = value
    }
    setData(newData)
  }
  const getDisabledSetPwdBtn = () => {
    if (
      msg ||
      loading ||
      !data ||
      // !data?.[configFieldData.confirmPwd] ||
      !data?.[configFieldData.newPwd]
    ) {
      return true
    }
    return false
  }

  const onHandleKeyDown = e => {
    if (!getDisabledSetPwdBtn()) {
      fnList?.handlePressEnter && fnList?.handlePressEnter(e, onResetPassword)
    }
  }
  const onResetPassword = () => {
    let canCallReset = true
    // if (data && Object.keys(data)?.length == 2) {
    // if (
    //   data?.[configFieldData.confirmPwd] !== data?.[configFieldData.newPwd]
    // ) {
    //   canCallReset = false
    //   setMsg("Mật khẩu chưa khớp")
    // }
    // else if (
    //   !checkValidPass(data?.[configFieldData.confirmPwd]) ||
    //   !checkValidPass(data?.[configFieldData.newPwd])
    // ) {
    //   canCallReset = false
    //   setMsg("Nhập mật khẩu tối thiểu 9 ký tự")
    // }
    // } else {
    //   canCallReset = false
    // }
    if (canCallReset && fnList && fnList?.requestSetNewPwd) {
      setLoading(true)
      fnList?.requestSetNewPwd(data, {
        cbSuccess: data => {
          setLoading(false)
          // if (data) {
          //   showAlert({
          //     component: (
          //       <div className="tabdk active text-center" id="tabdk5">
          //         <div className="heading mb-30px">
          //           <h4 className="titledk">Cập nhật thành công</h4>
          //         </div>
          //         <i
          //           className="flaticon-check text-success"
          //           style={{
          //             fontSize: "70px",
          //             lineHeight: "80px",
          //             marginBottom: "25px",
          //           }}
          //         ></i>
          //         <div className="form-group">
          //           <p className="xam">
          //             Mật khẩu mới của bạn đã được tạo thành công
          //           </p>
          //           <b className="">Cảm ơn bạn đã đồng hành cùng Sigo nhé!</b>
          //         </div>
          //       </div>
          //     ),
          //   })
          // }
        },
        cbError: msg => {
          setLoading(false)
          if (msg) {
            setMsg(msg)
          }
        },
      })
    }
  }
  const onGetDescriptionMsg = () => {
    if (fnList?.onGetDescription) {
      return fnList?.onGetDescription()
    }
    return ""
  }
  return (
    <MyUI
      type="sg_loading_overlay"
      // isLoading={loading}
      showLoadingIcon={false}
    >
      <Wrap
        className="mui-enter-new-pwd tabdk"
        style={{ display: isActive ? "block" : "none" }}
      >
        <div className="header">
          {/* <Button
          color="hide-modal"
          onClick={() => {
            fnList?.onGoBack && fnList?.onGoBack()
          }}
        >
          <MdArrowBackIos />
        </Button> */}
          <div className="title">Tạo mật khẩu mới</div>
        </div>
        <div className="body">
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: onGetDescriptionMsg() }}
          ></div>
        </div>
        <div className="form-group relative mb-30px">
          <div
            className="btn-link hienpass"
            onClick={() => {
              setShowPwd(!showPwd)
            }}
          >
            {showPwd ? <MdOutlineRemoveRedEye /> : <ImEyeBlocked />}
          </div>
          <Input
            type={showPwd ? "text" : "password"}
            placeholder="Mật khẩu của bạn"
            autoComplete="off"
            value={data?.[configFieldData.newPwd]}
            key={keyUIInput}
            disabled={loading}
            autoFocus
            name="pass"
            data-divmessage="#messtaotk"
            className="line-bottom inputpwd"
            onChange={e => {
              handlePassword(configFieldData.newPwd, e.target.value)
            }}
            onKeyDown={onHandleKeyDown}
          />
        </div>
        {dfMsgInfo?.msg_info_pwd_create && (
          <span className="info-msg">{dfMsgInfo?.msg_info_pwd_create}</span>
        )}
        {/* <div className="form-group relative mb-30px">
        <div
          className="btn-link hienpass"
          onClick={() => {
            setShowConfirmPwd(!showConfirmPwd)
          }}
        >
          {showConfirmPwd ? <MdOutlineRemoveRedEye /> : <ImEyeBlocked />}
        </div>
        <Input
          type={showConfirmPwd ? "text" : "password"}
          placeholder="Nhập lại mật khẩu"
          autoComplete="off"
          key={keyUIInput}
          value={data?.[configFieldData.confirmPwd]}
          name="confirm-pass"
          data-divmessage="#messtaotk"
          className="line-bottom inputpwd"
          onChange={e => {
            handlePassword(configFieldData.confirmPwd, e.target.value)
          }}
        />
      </div>
      {dfMsgInfo?.msg_info_pwd_create && (
        <span className="info-msg">{dfMsgInfo?.msg_info_pwd_create}</span>
      )} */}
        {/* {msg && (
        <Error className="__msgerr">
          <BiInfoCircle />
          <MyUI type="html" html={msg} style={{ flex: 1 }} />
        </Error>
      )} */}
        {msg && (
          <Error className="__msgerr">
            <BiInfoCircle />
            <div>{msg}</div>
          </Error>
        )}
        {/* <div
        id="messlogin"
        className="showmessage"
        style={msg ? { display: "block" } : { display: "none" }}
      >
        {msg}
      </div> */}
        <hr className="divider-line solid mb-25px"></hr>
        <MyUI
          type="sg_button"
          onClick={onResetPassword}
          color="primary-v2"
          className="btn-lg btn-block btnforgotpwd"
          disabled={getDisabledSetPwdBtn()}
          loading={loading}
          btnName="Đăng nhập"
          loadingColor={"#fff"}
        ></MyUI>
      </Wrap>
    </MyUI>
  )
}
const Error = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-danger);
  font-size: 15px;
  margin: 5px 0;
  & > svg {
    margin-right: 0.25rem;
    width: 15px;
    height: 15px;
  }
`
const Wrap = styled.div`
  & .inputpwd {
    border: 1px solid #959292;
    border-radius: 8px;
    min-height: 46px;
    padding: 8px 12px;
  }
  & .hienpass {
    bottom: 11px;
    color: var(--color-ic-show-pwd);
  }
  & .divider-line {
    margin-top: 0 !important;
  }
  & .info-msg {
    padding-bottom: 25px;
  }
  & .body {
    & .description {
      color: var(--color-text-000);
      // span {
      //   font-weight: 600;
      // }
    }
  }
`
export default MyUIEnterNewPassword
